<template>
  <div style="width: 100%">
    <div style="width: 100vw; background-color: #fff; min-height: 100vh; position: relative" v-show="ishome">
      <div :class="$style['wrapper-home6']">
        <div :class="$style['game-container']">
          <div :class="$style['game-header']">
            <div :class="$style['screenshot-container']">
              <img :src="appInfo.image" :class="$style['screenshot-image']" />
             
            </div>
            <div :class="$style['game-info']">
              <div style="display: flex; align-items: flex-end">
                <span :class="$style['game-title']">{{ appInfo.ipa_name }}</span>
                <div :class="$style['official']">官方</div>
              </div>
              <span :class="$style['game-meta']">{{ $t('index.version') }}：{{ appInfo.xlversion }}</span>
              <span :class="$style['game-meta']">{{ $t('index.updateTime') }}：{{ appInfo.updatetime }}</span>
            </div>
          </div>
        </div>
        <img :src="qrcode" alt="" style="width: 140px; height: 140px; margin-top: 90px" v-if="!appInfo.logmassage && !appInfo.preview" />
        <div :class="$style['game-content']">
          <div  v-if="pcFlag" style="margin: 20px 0;">
            <span :class="$style['screenshot-label']" v-if="appInfo.preview">{{ $t('index.yy') + $t('index.jt') }}</span>
          </div>
          <div style="width: 100%;text-align: left;margin: 20px 0;"  v-else>
            <span :class="$style['screenshot-label']" v-if="appInfo.preview">{{ $t('index.yy') + $t('index.jt') }}</span>
          </div>
          <div :class="$style['scrollBox']" style="width: 100%; overflow-x: scroll" v-if="appInfo.preview">
            <div :class="$style['icon-group']" style="justify-content: center;" v-if="pcFlag">
              <img v-for="(src, index) in appInfo.preview" :key="index" :src="src" :class="$style['feature-icon']" />
            </div>
            <div :class="$style['icon-group']" v-else>
              <img v-for="(src, index) in appInfo.preview" :key="index" :src="src" :class="$style['feature-icon']" />
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: column" v-if="appInfo.logmassage && !pcFlag">
            <span :class="$style['section-title']">{{ $t('temp3.yyms') }}</span>
            <span :class="$style['feature-item']">{{ appInfo.logmassage }}</span>
          </div>
          <div style="width: 100%; display: flex; flex-direction: column;align-items: center;" v-if="appInfo.logmassage && pcFlag">
            <span :class="$style['section-title']">{{ $t('temp3.yyms') }}</span>
            <span :class="$style['feature-item']">{{ appInfo.logmassage }}</span>
          </div>
          <div :class="$style['download-button']" style="background-color: #999" v-if="cannotInstall">
            <div :class="$style['button-content']">
              <img src="../../../assets/download.png" alt="" style="width: 20px; height: 20px; margin-right: 5px" />
              <span style="color: #fff">{{ $t('index.no_support') }}{{ androidFlag ? $t('index.android') : ' IOS' }}</span>
            </div>
          </div>
          <div :class="$style['download-button']" @click="installApp(false)" v-else>
            <div :class="$style['button-content']">
              <img src="../../../assets/download.png" alt="" style="width: 20px; height: 20px; margin-right: 5px" />
              <span v-if="downloaded" :class="$style['button-label']">{{ $t('index.back_desktop') }}</span>
              <span v-else :class="$style['button-label']">{{ downloadFlag ? $t('index.installing') : $t('temp4.install') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin: 20px 0 40px; position: absolute; bottom: 20px; left: 0">
        <span style="color: #157df1; cursor: pointer" @click="dialogShow = true">{{ $t('index.disclaimer') }}</span>
        <!-- |
        <span style="color: #157df1; cursor: pointer" @click="report">{{ $t('index.djjb') }}</span> -->
      </div>
      <mu-dialog :open.sync="dialogShow" :title="$t('index.disclaimer')" @close="dialogShow = false">
        <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer1') }}</p>
        <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer2') }}</p>
        <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer3') }}</p>
      </mu-dialog>
      <report :baseUrl="baseUrl" :appInfo="appInfo" :appid="appInfo.id || 0" ref="report"></report>
    </div>
    <hongbao v-show="!ishome" @back="toggleBack" :appInfo="appInfo" :hongbaoAd="hongbaoAd" :whiteList="whiteList" :jumpObject="jumpObject" />
  </div>
</template>

<script>
import report from '../report/report.vue';
import { mixin } from '../../mixins/mixin.js';
import hongbao from './hongbao';
export default {
  mixins: [mixin],
  components: {
    report,
    hongbao,
  },
  data() {
    return {
      dialogShow: false,
    };
  },
  methods: {
    onDownloadGameClick() {},
  },
};
</script>

<style module lang="less">
* {
  box-sizing: border-box;
}
.wrapper-home6 {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  box-sizing: content-box; 
}

.game-container {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  width: 100%;
}

.game-header {
  align-self: flex-start;
  display: flex;
  flex-direction: row;
}

.screenshot-container {
  align-self: center;
  display: flex;
  flex-direction: column;
}

.screenshot-image {
  border-radius: 22px;
  flex-shrink: 0;
  width: 116px;
  height: 114px;
}

.screenshot-label {
  color: #000000;
  font-size: 18px;
  margin-top: 22px; 
  white-space: nowrap;
  margin-bottom: 20px;
  font-weight: 700;
}

.game-info {
  max-width: 252px;
  margin-left: 15px;
  align-self: flex-start;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
}

.game-title {
  color: #000000;
  font-size: 28px;
  margin-left: 0px;
}

.game-meta {
  color: #878785;
  font-size: 13px;
  white-space: pre-wrap;
  margin-top: 2px;
}

.game-content {
  width: 100%;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 150px;
}
.scrollBox{
  &::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.icon-group {
  display: flex;
  flex-direction: row;
}

.feature-icon {
  border-radius: 12px;
  flex-shrink: 0;
  width: 150px;
  margin-right: 15px;
}

.section-title {
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  margin-top: 34px;
  margin-left: 2px;
}

.game-tagline {
  color: #474747;
  font-size: 14px;
  margin-top: 12px;
  margin-left: 2px;
}

.feature-item {
  color: #666;
  font-size: 13px;
  margin-top: 5px;
  margin-left: 5px;
}

.download-button {
  background-color: #ff5e3e;
  height: 55px;
  margin-top: 38px;
  line-height: 55px;
  border-radius: 15px;
  width:300px;
  margin: 50px auto;
}

.button-content {
  justify-content: center;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.download-icon {
  border-radius: 2px;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
}

.button-label {
  color: #ffffe3;
  font-size: 16px;
  margin-left: 2px;
  white-space: nowrap;
}

.divider-line {
  background-color: #fefdff;
  border-color: #fdfef7;
  border-style: solid;
  border-width: 1px;
  width: 234px;
  height: 4px;
  margin-top: 196px;
}
.official {
  margin-left: 10px;
  border: 1px solid #c24034;
  color: #c24034;
  padding: 2px 5px;
  border-radius: 5px;
  background-color: rgba(194, 64, 52, 0.1);
  font-size: 12px;
  margin-bottom: 2px;
}
</style>
